<script>
import { createNamespacedHelpers } from 'vuex';
import { COURSE_DRAFT_INITIALIZE, COURSE_DRAFT_FILL } from '@/store/course/types';
import { ROUTE_COURSE_CREATE } from '@/router/names';

const { mapMutations } = createNamespacedHelpers('course');

export default {
    created() {
        const { id } = this.$route.params;
        this.initializeDraft();
        this.fillDraft({
            trainer_id: id,
        });
        this.$router.replace({
            name: ROUTE_COURSE_CREATE,
        });
    },
    methods: {
        ...mapMutations({
            initializeDraft: COURSE_DRAFT_INITIALIZE,
            fillDraft: COURSE_DRAFT_FILL,
        }),
    },
    render() {
        return null;
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/course/BootTrainer.vue